import React from 'react';
import Route from '../constants/Route';
import { NavTabWrapper, NavTab, navTabActiveClass } from './NavBar';

const AdminNavBar: React.FC<{}> = () => {
  return (
    <NavTabWrapper>
      <NavTab to={Route.AdminUsers} activeClassName={navTabActiveClass}>
        Users
      </NavTab>
      <NavTab to={Route.AdminDates} activeClassName={navTabActiveClass}>
        Holidays
      </NavTab>
    </NavTabWrapper>
  );
};

export default AdminNavBar;
